import * as React from "react"
import ContactPage from "../components/contact/contact-page"

const seo = {
    title: "Contact us",
    description: "Ask about Vibra One pricing, lead times for the UK and the EU, technical data or a plan for your office. Phone, email and a short form.",
}

const ContactUs = () => (
    <ContactPage
        seo={seo}
        title="Contact us"
        intro={
            <p style={{ marginBottom: 30 }}>
                Tell us a little about your office and what you need: how many people, how many calls, what the space looks like. We reply within one working day with prices, lead times and honest advice on how many booths you actually need.
            </p>
        }
    />
)

export default ContactUs
